<h3 mat-dialog-title class="title">
    Remove Pre-Start Candidate
</h3>
<mat-progress-bar *ngIf="isSubmitting" mode="indeterminate"></mat-progress-bar>

<mat-dialog-content class="pr-0 pb-0 dialog-body">
    <div class="dialog-body flex-row">
        <div class="flex-row flex-100">
            <div class="flex-col flex-100">
                <div class="info-banner dialog-gap">
                    <mat-icon class="info-banner__icon">info</mat-icon>
                    <span class="info-banner__text" data-qa-id="perm_offer_confirm_not_starting_modal_banner_text">Marking a candidate as removed will only remove them from the
                        pre-start dashboard. Their status will remain as "Offer Accepted." However, it should be noted
                        that they did not start.</span>
                </div>
                <nova-am-submittal-send-to-client-info-card [model]="viewModel.permPostOfferOfferModel"
                                                            [labelFlex]="labelFlex"
                                                            [dataFlex]="dataFlex">
                </nova-am-submittal-send-to-client-info-card>

                <div class="flex-row pt-0 dialog-buttons">
                    <div class="flex-75">
                        <div>
                            <button id="update"  mat-flat-button
                                    [disabled]=" isSubmitting" color="primary"
                                    (click)="onSubmit()"
                                    data-qa-id="perm_offer_confirm_not_starting_modal_remove_button">
                                REMOVE
                            </button>

                            <nova-am-submittal-status-update-cancel-button
                                data-qa-id="perm_offer_confirm_not_starting_modal_cancel_button"
                                (clicked)="closeDialog()"
                                #cancelButton></nova-am-submittal-status-update-cancel-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
